import React from "react";
import { Box, Divider, Grid, Paper } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Typography from "@material-ui/core/Typography";
import { loader } from "src/app-redux/gate-entry/gateEntrySlice";
import { useAppSelector } from "src/app-redux/hooks";
import TabHeader from "src/components/TabHeader/TabHeader";
import GateOutInput from "./components/GateOutInput";
import { useStyles } from "./components/style";
import { loader as loader2 } from "src/app-redux/vehicle/vehicleSlice";
import CommonLoader from "src/components/Loader/CommonLoader";

type Props = {};

export default function GateOut({}: Props): React.ReactElement {
  const classes = useStyles();
  const moduleName = "Gate Entry";
  const pageHeading = "Gate-Out";
  // Select from Store
  const loading = useAppSelector(loader);
  const loading2 = useAppSelector(loader2);

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} link={"/gate-entry"} />
      <Backdrop className={classes.backdrop} open={loading || loading2}>
        <CommonLoader />
      </Backdrop>
      <Box m={2} />
      <Grid container direction="row">
        <Grid item xs={12} md={12} className={classes.cardMainParent}>
          <Paper elevation={3} className={classes.cardMain}>
            <Box pl={2} pr={2}>
              <Grid container direction="row">
                <Grid item xs={12} md={7}>
                  <Typography className={classes.pageHeading}>{pageHeading}</Typography>
                </Grid>
              </Grid>
            </Box>
            <Box m={1}>
              <Divider />
            </Box>
            <div style={{ padding: "30px" }}>
              <GateOutInput />
            </div>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
